import { Switch } from '@flixbus/honeycomb-react';
import { useVoucherFormContext } from '../../Context';
import { DirectRideRule } from '../../../../types/Rules';

const MinimumTicketsAmount = () => {
  const {
    formState: {
      payload: { rules },
    },
    handleRuleChange,
  } = useVoucherFormContext();

  const rule = rules.filter(r => r.type === 'direct_ride')[0] as DirectRideRule | undefined;

  return (
    <Switch
      label='Only direct trips'
      id='direct-rides'
      defaultChecked={rule !== undefined}
      onChange={e => {
        handleRuleChange(
          {
            type: 'direct_ride',
          },
          !e.target.checked,
        );
      }}
    ></Switch>
  );
};

export default MinimumTicketsAmount;
